// extracted by mini-css-extract-plugin
export default {"more":"more___nPyKq","moreItem":"moreItem___YHRZU"};